module.exports = require('@nerdwallet/structured-content-core/with-data-dependencies');
